import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import {
    Button,
    InputControl,
    SegmentLoader,
    Row,
    Col,
    ButtonGroup,
    ButtonLink,
} from '@si-armes/dsfr-react';

import { STATUTS_METIER_ASSO } from 'utils/Statuts.MetierAsso.constant';
import { useForm, FormProvider } from 'react-hook-form';
import InputFiles from 'components/Commun/Form/InputFiles';
import { getAPI, postAPI, reinitialiseAPI } from 'store/apiReducer';
import { Link, useHistory } from 'react-router-dom';
import FileUploadeBack from 'components/form/InputFiles/Model/FileUploadeBack';
import {
    API_MODIFIER_INFORMATIONS_COMPTE,
    API_RECUPERER_INFORMATIONS_PERSONNELLES,
    CONTEXT_API_MODIFIER_INFORMATIONS_COMPTE,
    CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES,
} from 'constants/apiUrls.constants';
import usagerClientReducer from 'store/usagerReducer';
import RoutesEcranGestion from '../gestion/routes';
import ModaleDeconnexion from '../../../../components/ModaleDeconnexion/ModaleDeconnexion';
import CertificatMedicalModele from '../../../../media/modele_certificat_medical.pdf';
import { getPatternHookFormValidation } from '../../../../utils/utils';
import { REGEXP_NUMERO_GUICHET_UNIQUE } from '../../../../constants/contraintes.constants';
import RoutesMonCompte from '../routes';
import { getPath } from '../../../../utils/router';
import NombreLicenciesAdherents from './NombreLicenciesAdherents';
import {
    FEATURE_APPEL_API_FFTIR,
    isFeatureActive,
} from '../../../../components/FeatureFlipping/featureFlipping.func';
import InfoChampsObligatoire from '../../../../components/form/infoObligatoire/InfoChampsObligatoire';

const ModifierInformationsCompte = ({
    postApi,
    getApi,
    reinitialiseApi,
    isLoadingCompteUsager,
    dataCompteUsager,
    erreurModifierInformationsCompte,
    messageModifierInformationsCompte,
    isLoadingModifierInformationsCompte,
    dataModifierInformationsCompte,
}) => {
    const hookForm = useForm({ mode: 'onChange' });
    const { formState, handleSubmit, register, reset, setValue, watch, getValues } = hookForm;
    const [isCertificatMedicalARSRequired, setCertificatMedicalARSRequired] = useState(false);
    const [isAttestationCompetiteurRequired, setIsAttestationCompetiteurRequired] = useState(false);
    const [isDataGenere, setDataGenere] = useState(false);
    const [ouvrirModale, setOuvrirModale] = useState(false);
    const history = useHistory();
    const { data: featureFlipping } = useSelector((state) => state.featureFlipping);
    const isMetierAssociation = dataCompteUsager?.informationsMetiersAssociations;
    const isCollectionneur = !!dataCompteUsager?.personnePhysique?.carteCollectionneur;

    const sousStatutUtilisateur =
        dataCompteUsager?.informationsMetiersAssociations?.sousStatut || null;

    const isFFTIR = [
        STATUTS_METIER_ASSO.ASSOCIATION_MORALE_FFTIR,
        STATUTS_METIER_ASSO.ASSOCIATION_MORALE_AFFILIE_FFTIR,
    ].includes(sousStatutUtilisateur);

    useEffect(() => {
        reinitialiseApi(CONTEXT_API_MODIFIER_INFORMATIONS_COMPTE);
        reinitialiseApi(CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES);
        getApi(
            usagerClientReducer,
            API_RECUPERER_INFORMATIONS_PERSONNELLES,
            CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES,
        );
        return () => {
            reinitialiseApi(CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES);
        };
    }, []);

    const redirectToEcranGestion = () => {
        history.push(getPath(RoutesEcranGestion));
    };

    const genererFichier = (file, name) => {
        const fichier = new FileUploadeBack({
            filename: file.filename,
            uuid: file.uuid,
        });
        setValue(name, [fichier]);
    };

    useEffect(() => {
        setDataGenere(false);

        if (isLoadingCompteUsager === false && dataCompteUsager) {
            const { permisChasser, licenceTir, licenceBallTrap, licenceSki } =
                dataCompteUsager.licences;
            const { certificatMedicalARS, attestationCompetiteur } =
                dataCompteUsager.personnePhysique;

            // data compte
            const compteDataForm = {
                identifiantConnexion: dataCompteUsager.compte.username,
                numeroSia: dataCompteUsager.personnePhysique.numeroSia,
                numeroCarteCollectionneur:
                    dataCompteUsager.personnePhysique.carteCollectionneur?.numero,
            };

            // data permis de chasser
            let permisChasserDataForm = null;
            if (permisChasser) {
                permisChasserDataForm = {
                    numeroPermisChasser: permisChasser.numero,
                    numeroGuichetUnique: permisChasser.numeroGuichetUnique,
                };
            }

            // data licence de tir
            let licenceTirDataForm = null;
            if (licenceTir) {
                licenceTirDataForm = {
                    numeroLicenceTir: licenceTir.numero,
                };
            }

            // data licence de ball-trap
            let licenceBallTrapDataForm = null;
            if (licenceBallTrap) {
                licenceBallTrapDataForm = {
                    numeroLicenceBallTrap: licenceBallTrap.numero,
                };
            }

            // data licence de ski
            let licenceSkiDataForm = null;
            if (licenceSki) {
                licenceSkiDataForm = {
                    numeroLicenceSki: licenceSki.numero,
                };
            }

            reset({
                ...compteDataForm,
                ...permisChasserDataForm,
                ...licenceTirDataForm,
                ...licenceBallTrapDataForm,
                ...licenceSkiDataForm,
            });

            // fichier permis chasser
            if (permisChasser) {
                genererFichier(permisChasser.permisChasserFichier, 'permisChasserFichier');

                if (permisChasser.validationPermisChasserFichier) {
                    genererFichier(
                        permisChasser.validationPermisChasserFichier,
                        'validationPermisChasserFichier',
                    );
                }
            }

            // fichier licence tir
            if (
                !isFeatureActive(featureFlipping, FEATURE_APPEL_API_FFTIR) &&
                licenceTir?.licenceFichier
            ) {
                genererFichier(licenceTir.licenceFichier, 'licenceTirFichier');
            }

            // fichier licence ball-trap
            if (licenceBallTrap?.licenceFichier) {
                genererFichier(licenceBallTrap.licenceFichier, 'licenceBallTrapFichier');
            }

            // fichier licence ski
            if (licenceSki?.licenceFichier) {
                genererFichier(licenceSki.licenceFichier, 'licenceSkiFichier');
            }

            // fichier certificat medical
            if (certificatMedicalARS) {
                genererFichier(certificatMedicalARS, 'certificatMedicalARSFichier');
                setCertificatMedicalARSRequired(true);
            } else {
                setCertificatMedicalARSRequired(false);
            }

            // fichier attestation competiteur
            if (attestationCompetiteur) {
                genererFichier(attestationCompetiteur, 'attestationCompetiteur');
                setIsAttestationCompetiteurRequired(true);
            } else {
                setIsAttestationCompetiteurRequired(false);
            }
        } else {
            reset({});
        }

        setDataGenere(true);
    }, [dataCompteUsager]);

    useEffect(() => {
        if (
            dataModifierInformationsCompte &&
            isLoadingModifierInformationsCompte === false &&
            erreurModifierInformationsCompte === false
        ) {
            reinitialiseApi(CONTEXT_API_MODIFIER_INFORMATIONS_COMPTE);
            if (dataModifierInformationsCompte.changementDeRole) {
                setOuvrirModale(true);
            } else {
                redirectToEcranGestion();
            }
        }
    }, [
        erreurModifierInformationsCompte,
        messageModifierInformationsCompte,
        isLoadingModifierInformationsCompte,
        dataModifierInformationsCompte,
    ]);

    const formaterChampsNumeroGuichetUnique = (value) => {
        return value.replace(/\D/g, '');
    };

    const hasFormValid = () => {
        if (dataCompteUsager) {
            const validPermisChasser =
                !getValues('numeroPermisChasser') ||
                (getValues('numeroPermisChasser') &&
                    getValues('permisChasserFichier') &&
                    !!getValues('permisChasserFichier')[0]);

            const validLicenceTir =
                !getValues('numeroLicenceTir') ||
                (getValues('numeroLicenceTir') &&
                    getValues('licenceTirFichier') &&
                    !!getValues('licenceTirFichier')[0]) ||
                (getValues('numeroLicenceTir') &&
                    isFeatureActive(featureFlipping, FEATURE_APPEL_API_FFTIR)) ||
                dataCompteUsager.licences?.licenceTir?.isAncienLicencie;

            const validLicenceBallTrap =
                !getValues('numeroLicenceBallTrap') ||
                (getValues('numeroLicenceBallTrap') &&
                    getValues('licenceBallTrapFichier') &&
                    !!getValues('licenceBallTrapFichier')[0]) ||
                dataCompteUsager.licences?.licenceBallTrap?.isAncienLicencie;

            const validLicenceSki =
                !getValues('numeroLicenceSki') ||
                (getValues('numeroLicenceSki') &&
                    getValues('licenceSkiFichier') &&
                    !!getValues('licenceSkiFichier')[0]) ||
                dataCompteUsager.licences?.licenceSki?.isAncienLicencie;

            const validPermisChasserValidation =
                !getValues('numeroGuichetUnique') ||
                (getValues('numeroGuichetUnique') &&
                    getValues('validationPermisChasserFichier') &&
                    !!getValues('validationPermisChasserFichier')[0]);

            const { certificatMedicalARS } = dataCompteUsager.personnePhysique;

            const validCertificatMedical =
                !certificatMedicalARS ||
                (certificatMedicalARS &&
                    getValues('certificatMedicalARSFichier') &&
                    !!getValues('certificatMedicalARSFichier')[0]);

            return (
                validPermisChasser &&
                validPermisChasserValidation &&
                validLicenceTir &&
                validLicenceBallTrap &&
                validLicenceSki &&
                validCertificatMedical
            );
        }

        return false;
    };

    const formaterModifications = async (dataForm) => {
        return {
            numeroPermisChasser: dataForm?.numeroPermisChasser ?? null,
            numeroGuichetUnique: dataForm?.numeroGuichetUnique ?? null,
            permisChasserFichier:
                dataForm?.permisChasserFichier && dataForm?.permisChasserFichier?.length
                    ? await dataForm.permisChasserFichier[0].getFileToSend()
                    : null,
            guichetUniqueFichier:
                dataForm?.validationPermisChasserFichier &&
                dataForm?.validationPermisChasserFichier?.length
                    ? await dataForm.validationPermisChasserFichier[0].getFileToSend()
                    : null,
            licenceTir: dataCompteUsager?.licences?.licenceTir
                ? {
                      isAncienLicencie: dataCompteUsager.licences.licenceTir?.isAncienLicencie,
                      numero: dataForm?.numeroLicenceTir?.length
                          ? dataForm?.numeroLicenceTir
                          : null,
                  }
                : null,
            licenceTirFichier:
                dataForm?.licenceTirFichier && dataForm?.licenceTirFichier?.length
                    ? await dataForm.licenceTirFichier[0].getFileToSend()
                    : null,
            licenceBallTrap: dataCompteUsager?.licences?.licenceBallTrap
                ? {
                      isAncienLicencie: dataCompteUsager.licences.licenceBallTrap?.isAncienLicencie,
                      numero: dataForm?.numeroLicenceBallTrap?.length
                          ? dataForm.numeroLicenceBallTrap
                          : null,
                  }
                : null,
            licenceBallTrapFichier:
                dataForm?.licenceBallTrapFichier && dataForm?.licenceBallTrapFichier?.length
                    ? await dataForm.licenceBallTrapFichier[0].getFileToSend()
                    : null,
            licenceSki: dataCompteUsager?.licences?.licenceSki
                ? {
                      isAncienLicencie: dataCompteUsager.licences.licenceSki?.isAncienLicencie,
                      numero: dataForm?.numeroLicenceSki?.length ? dataForm.numeroLicenceSki : null,
                  }
                : null,
            licenceSkiFichier:
                dataForm?.licenceSkiFichier && dataForm?.licenceSkiFichier?.length
                    ? await dataForm.licenceSkiFichier[0].getFileToSend()
                    : null,
            certificatMedicalARS:
                dataForm?.certificatMedicalARSFichier &&
                dataForm?.certificatMedicalARSFichier?.length
                    ? await dataForm.certificatMedicalARSFichier[0].getFileToSend()
                    : null,
            attestationCompetiteur:
                dataForm?.attestationCompetiteur && dataForm?.attestationCompetiteur?.length
                    ? await dataForm.attestationCompetiteur[0].getFileToSend()
                    : null,
        };
    };

    const onSubmit = async (dataForm) => {
        if (dataForm && hasFormValid) {
            const dataFormat = await formaterModifications(dataForm);

            reinitialiseApi(CONTEXT_API_MODIFIER_INFORMATIONS_COMPTE);
            postApi(
                usagerClientReducer,
                API_MODIFIER_INFORMATIONS_COMPTE,
                dataFormat,
                CONTEXT_API_MODIFIER_INFORMATIONS_COMPTE,
            );
        }
    };

    return (
        <SegmentLoader isLoading={isLoadingCompteUsager || !isDataGenere}>
            {ouvrirModale && <ModaleDeconnexion />}

            {erreurModifierInformationsCompte && messageModifierInformationsCompte && (
                <Row>
                    <Col col={12}>
                        <p className="fr-error">{messageModifierInformationsCompte}</p>
                    </Col>
                </Row>
            )}

            <Row>
                <Col col={12}>
                    <h1>Modification des informations de mon compte</h1>
                </Col>
            </Row>
            <Row>
                <Col col={12}>
                    <p>
                        Vous pouvez modifier directement vos informations personnelles en saisissant
                        les informations dans les champs ci-dessous. Certaines informations
                        personnelles sont grisées car elles ne sont pas modifiables.
                    </p>
                </Col>
            </Row>
            <Row>
                <Col col={12}>
                    <InfoChampsObligatoire className="" />
                </Col>
            </Row>
            <Row>
                <Col col={12}>
                    <p>
                        La taille maximale autorisée de votre document est 5Mo. Les formats acceptés
                        sont .png, .pdf, .jpeg, .jpg.
                    </p>
                </Col>
            </Row>

            {isFFTIR && <NombreLicenciesAdherents />}

            <FormProvider {...hookForm}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Row gutters>
                        <Col col={12} md={6}>
                            <InputControl
                                autocomplete="username"
                                name="identifiantConnexion"
                                label="Identifiant de connexion"
                                {...register('identifiantConnexion')}
                                disabled
                            />
                        </Col>
                    </Row>
                    <Row gutters className="margin-bottom-sm">
                        <Col col={12} md={6}>
                            <InputControl
                                name="numeroSia"
                                label="Numéro SIA"
                                {...register('numeroSia')}
                                disabled
                            />
                        </Col>
                    </Row>

                    {isCollectionneur && (
                        <Row gutters className="margin-bottom-sm">
                            <Col col={12} md={6}>
                                <InputControl
                                    name="numeroCarteCollectionneur"
                                    label="Numéro de carte de collectionneur"
                                    {...register('numeroCarteCollectionneur')}
                                    disabled
                                />
                            </Col>
                        </Row>
                    )}

                    {dataCompteUsager && dataCompteUsager.licences.permisChasser && (
                        <>
                            <Row gutters className="margin-bottom-sm">
                                <Col col={12} md={6}>
                                    <InputControl
                                        name="numeroPermisChasser"
                                        label="Numéro de permis de chasser"
                                        {...register('numeroPermisChasser')}
                                        required
                                    />
                                </Col>
                                <Col col={12} md={6}>
                                    <InputFiles
                                        name="permisChasserFichier"
                                        label="Modifier mon permis de chasser"
                                        disabled={!watch('numeroPermisChasser')}
                                        required
                                    />
                                </Col>
                            </Row>

                            <Row gutters className="margin-bottom-sm">
                                <Col col={12} md={6}>
                                    <InputControl
                                        name="numeroGuichetUnique"
                                        label="Numéro de guichet de la validation du permis de chasser"
                                        {...register('numeroGuichetUnique', {
                                            pattern: getPatternHookFormValidation(
                                                REGEXP_NUMERO_GUICHET_UNIQUE,
                                                'numero guichet unique',
                                                'Veuillez renseigner a minima 14 caractères',
                                            ),
                                        })}
                                        state={
                                            formState.errors?.numeroGuichetUnique ? 'error' : null
                                        }
                                        message={formState.errors?.numeroGuichetUnique?.message}
                                        maskFonction={formaterChampsNumeroGuichetUnique}
                                        minLength="14"
                                        disabled={!watch('numeroPermisChasser')}
                                    />
                                </Col>
                                <Col col={12} md={6}>
                                    <InputFiles
                                        name="validationPermisChasserFichier"
                                        label="Ajouter ma validation de permis de chasser"
                                        required={watch('numeroGuichetUnique')}
                                        disabled={!watch('numeroGuichetUnique')}
                                    />
                                </Col>
                            </Row>
                        </>
                    )}

                    {dataCompteUsager && dataCompteUsager.licences.licenceTir && (
                        <Row gutters className="margin-bottom-sm">
                            <Col col={12} md={6}>
                                <InputControl
                                    id="numeroLicenceTir"
                                    name="numeroLicenceTir"
                                    label={
                                        !dataCompteUsager.licences.licenceTir.isAncienLicencie
                                            ? 'Numéro de licence de Tir *'
                                            : 'Numéro ancienne licence de Tir'
                                    }
                                    {...register('numeroLicenceTir', {
                                        required: !dataCompteUsager.licences.licenceTir
                                            .isAncienLicencie
                                            ? 'Le champ est obligatoire'
                                            : false,
                                    })}
                                    required={
                                        !dataCompteUsager.licences.licenceTir.isAncienLicencie
                                            ? 'Le champ est obligatoire'
                                            : false
                                    }
                                    state={formState.errors?.numeroLicenceTir ? 'error' : null}
                                    message={formState.errors?.numeroLicenceTir?.message}
                                />
                            </Col>
                            {!isFeatureActive(featureFlipping, FEATURE_APPEL_API_FFTIR) && (
                                <Col col={12} md={6}>
                                    <InputFiles
                                        name="licenceTirFichier"
                                        label={
                                            !dataCompteUsager.licences.licenceTir.isAncienLicencie
                                                ? 'Modifier ma licence de Tir'
                                                : 'Modifier mon ancienne licence de Tir'
                                        }
                                        disabled={
                                            !dataCompteUsager.licences.licenceTir.isAncienLicencie
                                                ? !watch('numeroLicenceTir')
                                                : false
                                        }
                                        required={
                                            !dataCompteUsager.licences.licenceTir.isAncienLicencie
                                        }
                                    />
                                </Col>
                            )}
                        </Row>
                    )}

                    {!isMetierAssociation && (
                        <Row gutters className="margin-bottom-sm">
                            <Col col={12} md={6}>
                                <p className="fr-label">
                                    <span className="fr-label-texte">Attestation compétiteur</span>
                                </p>
                            </Col>
                            <Col col={12} md={6}>
                                <InputFiles
                                    name="attestationCompetiteur"
                                    label="Ajouter mon attestation compétiteur"
                                    texteAide={null}
                                    required={isAttestationCompetiteurRequired}
                                />
                            </Col>
                        </Row>
                    )}

                    {dataCompteUsager && dataCompteUsager.licences.licenceBallTrap && (
                        <Row gutters className="margin-bottom-sm">
                            <Col col={12} md={6}>
                                <InputControl
                                    id="numeroLicenceBallTrap"
                                    name="numeroLicenceBallTrap"
                                    label={
                                        !dataCompteUsager.licences.licenceBallTrap.isAncienLicencie
                                            ? 'Numéro de licence de Ball Trap'
                                            : 'Numéro ancienne licence de Ball Trap'
                                    }
                                    {...register('numeroLicenceBallTrap')}
                                    required={
                                        !dataCompteUsager.licences.licenceBallTrap.isAncienLicencie
                                    }
                                />
                            </Col>
                            <Col col={12} md={6}>
                                <InputFiles
                                    name="licenceBallTrapFichier"
                                    label={
                                        !dataCompteUsager.licences.licenceBallTrap.isAncienLicencie
                                            ? 'Modifier ma licence de Ball Trap'
                                            : 'Modifier mon ancienne licence de Ball-Trap '
                                    }
                                    disabled={
                                        !dataCompteUsager.licences.licenceBallTrap.isAncienLicencie
                                            ? !watch('numeroLicenceBallTrap')
                                            : false
                                    }
                                    required={
                                        !dataCompteUsager.licences.licenceBallTrap.isAncienLicencie
                                    }
                                />
                            </Col>
                        </Row>
                    )}

                    {dataCompteUsager && dataCompteUsager.licences.licenceSki && (
                        <Row gutters className="margin-bottom-sm">
                            <Col col={12} md={6}>
                                <InputControl
                                    id="numeroLicenceSki"
                                    name="numeroLicenceSki"
                                    label={
                                        !dataCompteUsager.licences.licenceSki.isAncienLicencie
                                            ? 'Numéro de licence de Ski'
                                            : 'Numéro ancienne licence de Ski'
                                    }
                                    {...register('numeroLicenceSki')}
                                    required={
                                        !dataCompteUsager.licences.licenceSki.isAncienLicencie
                                    }
                                />
                            </Col>
                            <Col col={12} md={6}>
                                <InputFiles
                                    name="licenceSkiFichier"
                                    label={
                                        !dataCompteUsager.licences.licenceSki.isAncienLicencie
                                            ? 'Modifier ma licence de Ski'
                                            : 'Modifier mon ancienne licence de Ski '
                                    }
                                    disabled={
                                        !dataCompteUsager.licences.licenceSki.isAncienLicencie
                                            ? !watch('numeroLicenceSki')
                                            : false
                                    }
                                    required={
                                        !dataCompteUsager.licences.licenceSki.isAncienLicencie
                                    }
                                />
                            </Col>
                        </Row>
                    )}

                    {!isMetierAssociation && !isCollectionneur && (
                        <Row gutters className="margin-bottom-sm">
                            <Col col={12} md={6}>
                                <p className="fr-label margin0">
                                    <span className="fr-label-texte">
                                        Ajouter un nouveau profil
                                    </span>
                                    <span className="fr-hint-text">
                                        L’ajout de profil permet d’associer un profil supplémentaire
                                        à votre compte. Il est possible d’ajouter un seul profil à
                                        la fois. La création de ce nouveau profil entraine
                                        automatiquement la déconnexion de votre compte. Ceci, afin
                                        de permettre la réinitialisation des droits propres à ce
                                        profil.
                                    </span>
                                </p>
                            </Col>
                            <Col col={12} md={6}>
                                <p className="fr-label margin0">
                                    <span className="fr-label-texte">
                                        Ajouter un nouveau profil
                                    </span>
                                </p>
                                <ButtonLink
                                    as={Link}
                                    to={getPath(RoutesMonCompte.subroutes.ajouterPersona)}
                                    icon="fr-icon-user-add-fill"
                                    iconPosition="left"
                                    variant="secondary"
                                    className="margin-top-xs margin-right-sm"
                                >
                                    Ajout de profil
                                </ButtonLink>
                            </Col>
                        </Row>
                    )}

                    <Row gutters className="margin-bottom-sm">
                        <Col col={12} md={6}>
                            <div className="fr-label">
                                <span className="fr-label-texte">Certificat Médical</span>
                                <span className="fr-hint-text">
                                    Certificat médical attestant de l&apos;absence
                                    d&apos;incompatibilité de l&apos;état de santé d&apos;un
                                    particulier avec la détention d&apos;une arme à feu. Le modèle
                                    proposé ci-dessous doit être rempli et signé par un médecin
                                    avant d&apos;être importé dans le SIA.
                                </span>
                                <div>
                                    <a
                                        href={CertificatMedicalModele}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                    >
                                        Télécharger le modèle de certificat médical.
                                    </a>
                                </div>
                            </div>
                        </Col>
                        <Col col={12} md={6}>
                            <InputFiles
                                name="certificatMedicalARSFichier"
                                label="Ajouter mon certificat médical"
                                texteAide={null}
                                required={isCertificatMedicalARSRequired}
                            />
                        </Col>
                    </Row>
                    <Row className="margin-top-lg">
                        <Col col={12}>
                            <ButtonGroup align="right" inline>
                                <Button
                                    name="retour"
                                    variant="secondary"
                                    onClick={redirectToEcranGestion}
                                >
                                    Retour
                                </Button>
                                <Button
                                    name="valider"
                                    variant="primary"
                                    type="submit"
                                    disabled={!hasFormValid()}
                                    isLoading={isLoadingModifierInformationsCompte}
                                >
                                    Enregistrer les modifications
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Row>
                </form>
            </FormProvider>
        </SegmentLoader>
    );
};

ModifierInformationsCompte.propTypes = {
    postApi: PropTypes.func.isRequired,
    getApi: PropTypes.func.isRequired,
    reinitialiseApi: PropTypes.func.isRequired,
    dataCompteUsager: PropTypes.shape({
        informationsMetiersAssociations: PropTypes.object,
        compte: PropTypes.shape({
            username: PropTypes.string.isRequired,
        }).isRequired,
        licences: PropTypes.shape({
            permisChasser: PropTypes.shape({
                numero: PropTypes.string.isRequired,
                numeroGuichetUnique: PropTypes.string,
                permisChasserFichier: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }).isRequired,
                validationPermisChasserFichier: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }),
            }),
            licenceTir: PropTypes.shape({
                numero: PropTypes.string,
                isAncienLicencie: PropTypes.bool.isRequired,
                licenceFichier: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }),
            }),
            licenceBallTrap: PropTypes.shape({
                numero: PropTypes.string,
                licenceFichier: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }),
                isAncienLicencie: PropTypes.bool.isRequired,
            }),
            licenceSki: PropTypes.shape({
                numero: PropTypes.string,
                licenceFichier: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }),
                isAncienLicencie: PropTypes.bool.isRequired,
            }),
        }),
        personnePhysique: PropTypes.shape({
            numeroSia: PropTypes.string.isRequired,
            certificatMedicalARS: PropTypes.shape({
                uuid: PropTypes.string.isRequired,
                filename: PropTypes.string.isRequired,
            }),
            attestationCompetiteur: PropTypes.shape({
                uuid: PropTypes.string.isRequired,
                filename: PropTypes.string.isRequired,
            }),
            carteCollectionneur: PropTypes.shape({
                numero: PropTypes.string.isRequired,
                dateFinValidite: PropTypes.string,
                fichier: PropTypes.shape({
                    uuid: PropTypes.string.isRequired,
                    filename: PropTypes.string.isRequired,
                }),
            }),
        }).isRequired,
        typeCompte: PropTypes.array.isRequired,
    }),
    isLoadingCompteUsager: PropTypes.bool,
    erreurModifierInformationsCompte: PropTypes.any,
    messageModifierInformationsCompte: PropTypes.any,
    isLoadingModifierInformationsCompte: PropTypes.bool,
    dataModifierInformationsCompte: PropTypes.shape({
        changementDeRole: PropTypes.bool.isRequired,
    }),
};

export default connect(
    (state) => {
        const { isLoading: isLoadingCompteUsager, data: dataCompteUsager } =
            state.monCompte.recupererInformationsPersonnelles;
        const {
            isLoading: isLoadingModifierInformationsCompte,
            erreur: erreurModifierInformationsCompte,
            message: messageModifierInformationsCompte,
            data: dataModifierInformationsCompte,
        } = state.monCompte.modifierInformationsCompte;
        return {
            dataCompteUsager,
            isLoadingCompteUsager,
            erreurModifierInformationsCompte,
            messageModifierInformationsCompte,
            isLoadingModifierInformationsCompte,
            dataModifierInformationsCompte,
        };
    },
    {
        getApi: getAPI,
        postApi: postAPI,
        reinitialiseApi: reinitialiseAPI,
    },
)(ModifierInformationsCompte);
